import { groq } from 'next-sanity';
import { z } from 'zod';

import { jobSchema } from '#/lib/jobs';

import { page, SanityPage } from './pageProps';
import { SanitySite } from './site';

export const PageProps = z.object({
  page: SanityPage,
  site: SanitySite,
  initialData: z.object({ jobs: jobSchema.nullable().optional() }).optional(),
  isPreview: z.boolean().optional(),
});
export type PageProps = z.infer<typeof PageProps>;

/**
 * The pageprops and draft page props are the same except we don't allow homepge, error404, or error500 pages to be queried in production. We keep them in draft mode to allow for previewing.
 */
export const pageProps = groq`
  *[_type == 'page' && 
  !(_id in [
    *[_id == "site"][0].error404page._ref,
    *[_id == "site"][0].error500page._ref, 
    *[_id == "site"][0].homepage._ref]
  ) && slug.current == $slug][0] ${page}
`;
export const draftPageProps = groq`*[_type == 'page' && slug.current == $slug][0] ${page}`;
